<div class="m-4">
  <mat-card class="p-4">
    <h3>Onboarding</h3>
    <p class="text-muted">
      Siga os passos para inserir os dados necessários para utilizar o
      <strong class="text-hub-primary">{{ appName }}</strong>
    </p>
    <mat-stepper
      #stepper
      linear
      labelPosition="bottom"
      [selectedIndex]="selectedIndex"
    >
      <mat-step label="Benefícios" [completed]="(onboardingStatus ?? 1) > 1">
        <ng-template matStepContent>
          <app-onboarding-beneficios
            (next)="finalizeBeneficios()"
          ></app-onboarding-beneficios>
        </ng-template>
      </mat-step>
      <mat-step
        [optional]="true"
        label="Empresa"
        [completed]="(onboardingStatus ?? 1) > 1"
      >
        <ng-template matStepContent>
          <app-onboarding-empresa
            (next)="finalizeEmpresa()"
          ></app-onboarding-empresa>
        </ng-template>
      </mat-step>
      <mat-step label="Contrato" [completed]="(onboardingStatus ?? 1) > 2">
        <ng-template matStepContent>
          <app-onboarding-contrato
            (next)="finalizeContrato()"
          ></app-onboarding-contrato>
        </ng-template>
      </mat-step>
      <mat-step label="Beneficiários" [completed]="(onboardingStatus ?? 1) > 3">
        <app-onboarding-beneficiarios
          (finalize)="finalizeBeneficiarios()"
        ></app-onboarding-beneficiarios>
      </mat-step>
    </mat-stepper>
  </mat-card>
</div>
